/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowGraph } from '../../models/workflow-graph';

export interface CasesCaseIdWorkflowGet$Params {
  caseId: string;
}

export function casesCaseIdWorkflowGet(http: HttpClient, rootUrl: string, params: CasesCaseIdWorkflowGet$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowGraph>> {
  const rb = new RequestBuilder(rootUrl, casesCaseIdWorkflowGet.PATH, 'get');
  if (params) {
    rb.path('caseId', params.caseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowGraph>;
    })
  );
}

casesCaseIdWorkflowGet.PATH = '/cases/{caseId}/workflow';
